import React from "react";
import { IconProps } from "./types";

function IconInbox(props: IconProps) {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="inbox-02">
        <path
          id="Vector"
          d="M4.5 24H12.2639C13.6343 24 14.8871 24.7743 15.5 26C16.1129 27.2257 17.3657 28 18.7361 28H30.2639C31.6343 28 32.8871 27.2257 33.5 26C34.1129 24.7743 35.3657 24 36.7361 24H44.5M4.5 24V17.6C4.5 14.2397 4.5 12.5595 5.15396 11.2761C5.7292 10.1471 6.64708 9.2292 7.77606 8.65396C9.05953 8 10.7397 8 14.1 8H34.9C38.2603 8 39.9405 8 41.2239 8.65396C42.3529 9.2292 43.2708 10.1471 43.846 11.2761C44.5 12.5595 44.5 14.2397 44.5 17.6V24M4.5 24V30.4C4.5 33.7603 4.5 35.4405 5.15396 36.7239C5.7292 37.8529 6.64708 38.7708 7.77606 39.346C9.05953 40 10.7397 40 14.1 40H34.9C38.2603 40 39.9405 40 41.2239 39.346C42.3529 38.7708 43.2708 37.8529 43.846 36.7239C44.5 35.4405 44.5 33.7603 44.5 30.4V24"
          stroke="#64748B"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}

export default IconInbox;
